export type NotificationsTranslations = {
  goToMySurveys: string;
  goToSurvey: string;
  markAsRead: string;
  markAsUnread: string;
  unread: string;
  viewProfile: string;
};

export const notificationsTranslations: NotificationsTranslations = {
  goToMySurveys: 'My Certifications',
  goToSurvey: 'Go to survey',
  markAsRead: 'Mark as read',
  markAsUnread: 'Mark as unread',
  unread: 'Unread',
  viewProfile: 'View recipient profile',
};
